import React, { Suspense, useEffect, useState } from "react";
import "../commonStyle.css";
import { useSideScrollSticky } from "../CustomHooks/useSideScrollSticky";
import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import DesktopHeader from "../DesktopCommonComponents/DesktopHeader/DesktopHeader";
import { isMobile } from "../helperFunc";
import Header from "../Header/Header";
import useIsUserLoggedIn from "../CustomHooks/useIsUserLoggedIn";
import useAllUserData from "../CustomHooks/useAllUserData";
import PopularSupplies from "../CommonSuppliesComponent/PopularSupplies";
import PopularDemands from "../CommonSuppliesComponent/PopularDemands";
import WarehouseNearMe from "../CommonSuppliesComponent/WarehouseNearMe";
import RightDownloadLink from "../DownloadComponent/RightDownloadLink";
import NeedHelpRight from "../NeedHelp/NeedHelpRight";
import StickyFooter from "../StickyFooter/StickyFooter";
import DesktopFooter from "../DesktopCommonComponents/DesktopFooter/DesktopFooter";
import circle from "../Images/NotFound/notFound.jpg";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";

const NotFoundPage = (props) => {
  // const [login, setLogin] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const [userLoggedIn] = useIsUserLoggedIn();
  const sideScrollFunc = useSideScrollSticky();

  useEffect(() => {
    document.body?.classList.add("padding-top-unset");
    if (sideScrollFunc) {
      setTimeout(sideScrollFunc(), 1000);
    }
  }, []);
  const getNotificationData = async () => {
    const res = await HomePageServices.getUserNotification();
    // console.log(res);
    if (res?.data?.length) {
      setNotifications(res.data);
    }
  };
  useEffect(() => {
    userLoggedIn && isMobile && getNotificationData();
  }, [userLoggedIn]);

  return (
    <div className="stdFontStyle font-size16 letterSpacing015  line-height19 ">
      {!isMobile && <DesktopHeader isActive={""} />}
      {/* {show && <Registration show={show} setShow={setShow} />} */}
      {isMobile && (
        <Header
          login={userLoggedIn}
          notifications={notifications}
          appLogin={true}
        />
      )}
      <>
        <div className={!isMobile && `width-100 d-flex justify-content-center`}>
          <div
            className={` ${
              !isMobile && " width-100 padding-left-right100 row m-0 "
            }`}
          >
            <div
              className={`${
                !isMobile && "col-8 ml-0 mt-0 mb-0 pl-0 pr-0 pt-0 "
              } `}
            >
              <div
                className={`positionRelative text-center ${
                  isMobile
                    ? "margin-top16 padding-top16 padding-bottom8"
                    : "margin-top24 padding-top16 "
                } margin-bottom24`}
              >
                <img
                  src={circle}
                  height={isMobile ? "70" : "80"}
                  width={isMobile ? "65" : "75"}
                />
                <div className={` text-center`}>
                  <HeadLines
                    text="Oh! Page not found"
                    className={`colorDark9 ${
                      isMobile
                        ? "font-size16 line-height19 letterSpacing05 margin-top16"
                        : "font-size24 line-height28 letterSpacing025 margin-top16 padding-top4"
                    } margin-left16 margin-right16 margin-top6`}
                  />
                </div>
              </div>
              {/* <PopularSupplies
                flag={true}
                heading="Popular Trade Interests"
                subHeading=""
              /> */}
              <PopularDemands
                flag={true}
                heading="Popular Trade Interests"
                subHeading=""
                newType="Supply"
                notFoundPage={true}
              />
              <WarehouseNearMe />
              {/* <CreateAccountWidget /> */}
              {/* <HeaderDownload /> */}
              {/* <ChnLangPref /> */}
              {/* <OptionsComponent /> */}
            </div>
            {!isMobile && (
              <div
                className={`${
                  !isMobile &&
                  "col-4 ml-0 margin-top24 mr-0 pr-0 pt-0 padding-left32 margin-bottom24"
                } `}
              >
                <div className="position-sticky sticky-sidebar">
                  <div className="sidebar">
                    <RightDownloadLink />
                    <NeedHelpRight />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
      {isMobile && <StickyFooter isActive="" />}
      {!isMobile && <DesktopFooter />}
    </div>
  );
};
export default NotFoundPage;
